import { Data } from "@core/content/types";
import {
  createCreatorContentStore,
  toTargetNames as toTargetNamesCore,
} from "@core/content/creator/CreatorContentStore";
import type { CreatorPayload } from "@core/content/creator/types";

export const toTargetNames = toTargetNamesCore;

/** Pre-loaded artwork data injected by SSR (launch-v4). */
const ssrPayload: CreatorPayload | undefined =
  typeof window !== "undefined"
    ? (window as any).__ARTWORK_DATA__
    : undefined;

let manualContent: Data[] = [];
/**
 * Payload the store initialises from. This app passes the locally cached
 * collection (see `localCollection.ts`), which takes precedence over anything
 * SSR injects — the point of the cache is that nothing is fetched at runtime.
 */
let injectedPayload: CreatorPayload | undefined = ssrPayload;

export let ContentData: Data[] = [...manualContent];
export let MicrositeData = { name: "", description: "", constructedCover: "" };
export let INITIAL_CONTENT_ID = "";
export let CreatorPayloadData: CreatorPayload | null = injectedPayload ?? null;

let creatorContentStore = createCreatorContentStore({ creatorDataSource: "", manualContent: [] });

export const configureCreatorContentStore = (options: {
  creatorDataSource: string;
  manualContent: Data[];
  /** Local cache; falls back to the SSR payload when absent. */
  injectedPayload?: CreatorPayload;
}): void => {
  manualContent = options.manualContent;
  injectedPayload = options.injectedPayload ?? ssrPayload;
  ContentData = [...manualContent];
  MicrositeData = { name: "", description: "", constructedCover: "" };
  INITIAL_CONTENT_ID = "";
  CreatorPayloadData = injectedPayload ?? null;
  creatorContentStore = createCreatorContentStore({
    creatorDataSource: options.creatorDataSource,
    manualContent,
    injectedPayload,
  });
};

export const initializeCreatorData = async (): Promise<void> => {
  const state = await creatorContentStore.initialize();
  ContentData = state.contentData;
  MicrositeData = state.micrositeData;
  INITIAL_CONTENT_ID = state.initialContentId;
  CreatorPayloadData = state.creatorPayload;
};

export const getContent = (id: string) => {
  return creatorContentStore.getContent(id);
};

export const getCreatorPayload = (): CreatorPayload | null => {
  return CreatorPayloadData;
};
